import type { Business } from '@/types'

interface BusinessRowProps {
  business: Business
  onClick: () => void
}

export function BusinessRow({ business, onClick }: BusinessRowProps) {
  const altNamesCount = business.alternative_names?.length || 0
  const creditCardsCount = business.credit_card_endings?.length || 0

  return (
    <tr
      className="hover:bg-gray-50 cursor-pointer"
      onClick={onClick}
      data-testid={`business-row-${business.id}`}
    >
      <td className="px-4 py-3 whitespace-nowrap">
        <span className="text-sm font-medium text-gray-900">{business.name}</span>
      </td>
      <td className="px-4 py-3 whitespace-nowrap">
        <span className="text-sm text-gray-500">
          {business.accounting_identifier || '—'}
        </span>
      </td>
      <td className="px-4 py-3 whitespace-nowrap">
        {altNamesCount > 0 ? (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            {altNamesCount} name{altNamesCount !== 1 ? 's' : ''}
          </span>
        ) : (
          <span className="text-sm text-gray-400">—</span>
        )}
      </td>
      <td className="px-4 py-3 whitespace-nowrap">
        {creditCardsCount > 0 ? (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            {creditCardsCount} card{creditCardsCount !== 1 ? 's' : ''}
          </span>
        ) : (
          <span className="text-sm text-gray-400">—</span>
        )}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-right">
        <svg
          className="w-5 h-5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </td>
    </tr>
  )
}
